import { FieldNameInputProps } from 'modules/queryBuilder/contexts';
import { useFilterOptionsWithFeatureFlags } from './hooks';
import { ConditionSingleValueStringSelect } from 'ui/queryBuilder/Selects';

export const CustomConditionFieldSelect = ({ options = [], ...props }: FieldNameInputProps) => {
  const filteredOptions = useFilterOptionsWithFeatureFlags(options);
  return <ConditionSingleValueStringSelect options={filteredOptions} {...props} />;
};
